<div
  id="fundraisingPlatformQuickView"
  class="offcanvas offcanvas-end"
  tabindex="-1"
  aria-labelledby="fundraisingPlatformQuickViewLabel"
  (hidden.bs.offcanvas)="onHidden()"
>
  <div class="offcanvas-header border-bottom">
    <div>
      <p class="text-uppercase small fw-semibold text-primary mb-1">
        Quick platform view
      </p>
      <h2 id="fundraisingPlatformQuickViewLabel" class="offcanvas-title h4">
        {{ result?.platformName || 'Platform details' }}
      </h2>
    </div>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="offcanvas"
      aria-label="Close quick platform view"
    ></button>
  </div>

  <div *ngIf="row && result" class="offcanvas-body d-flex flex-column">
    <div
      class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3"
    >
      <span
        class="badge border fw-normal"
        [ngClass]="evidenceBadgeClasses(result.evidence.status)"
      >
        {{ result.evidence.label }}
      </span>
      <span class="small text-body-secondary">{{ result.regionLabel }}</span>
    </div>

    <section aria-labelledby="quick-view-result-heading" aria-live="polite">
      <p
        id="quick-view-result-heading"
        class="text-uppercase small fw-semibold text-body-secondary mb-1"
      >
        Organization receives
      </p>
      <p class="display-6 fw-bold text-primary mb-1">
        {{ formatMoney(row.organizationReceivesCents) }}
      </p>
      <p class="small text-body-secondary mb-3">
        of {{ formatMoney(result.intendedGiftTotalCents) }} in intended online
        donations
      </p>

      <dl class="row g-2 small mb-0">
        <dt class="col-7 fw-normal text-body-secondary">
          {{ organizationCostLabel }}
        </dt>
        <dd class="col-5 text-end fw-semibold mb-0">
          {{ formatMoney(result.organizationCostCents) }}
        </dd>

        <ng-container *ngIf="showSupporterExtra">
          <dt class="col-7 fw-normal text-body-secondary">
            {{ supporterExtraLabel }}
          </dt>
          <dd
            class="col-5 text-end mb-0"
            [class.fw-semibold]="result.donorPaidExtraEstimated"
          >
            {{ supporterExtraValue }}
          </dd>
        </ng-container>
      </dl>
    </section>

    <section class="border rounded-3 bg-light p-3 mt-4">
      <p class="text-uppercase small fw-semibold text-body-secondary mb-1">
        Current setup
      </p>
      <p class="fw-bold mb-0">{{ currentCostModel }}</p>
      <p
        *ngIf="result.configurationUi?.contextNote"
        class="small text-body-secondary mt-1 mb-0"
      >
        {{ result.configurationUi?.contextNote }}
      </p>
    </section>

    <app-platform-options
      *ngIf="result.configurationUi && result.optionGroups.length"
      [platformId]="result.platformId"
      [optionGroups]="result.optionGroups"
      [selections]="result.optionSelections"
      [configurationUi]="result.configurationUi"
      [showSelectedSummary]="false"
      presentation="expanded"
      (optionChange)="optionChange.emit($event)"
    ></app-platform-options>

    <section class="border-top pt-3 mt-4">
      <p class="text-uppercase small fw-semibold text-body-secondary mb-1">
        Pricing
      </p>
      <p class="fw-semibold mb-2">{{ result.compactFeeFormula }}</p>
      <p class="small text-body-secondary mb-0">
        {{ result.evidence.description }}
      </p>
    </section>
  </div>

  <div *ngIf="row && result" class="border-top bg-body p-3">
    <div class="d-grid gap-2">
      <a
        *ngIf="row.detailPageUrl"
        class="btn btn-primary"
        [href]="row.detailPageUrl"
        (click)="fullPageClicked.emit(result.platformId)"
      >
        Explore full pricing &amp; scenarios
        <span aria-hidden="true">→</span>
      </a>

      <button
        type="button"
        class="btn btn-outline-primary"
        data-bs-dismiss="offcanvas"
        aria-label="Close quick platform view and return to comparison"
      >
        Back to comparison
      </button>
    </div>
  </div>
</div>
